const formatInputMoneyMYR = (value: any, maxDecimal = 2) => {
  const raw = String(value ?? "");
  const cleaned = raw.replace(/[^0-9.]/g, "");
  if (cleaned === "") return "";

  const firstDotIndex = cleaned.indexOf(".");
  const hasDot = firstDotIndex !== -1 && maxDecimal > 0;

  const intPartRaw = (hasDot ? cleaned.slice(0, firstDotIndex) : cleaned)
    .replace(/\D+/g, "")
    .replace(/^0+(?=\d)/, "");

  const intPart = intPartRaw === "" ? "0" : intPartRaw;
  const intFormatted = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  if (!hasDot) return intFormatted;

  const decimalPart = cleaned
    .slice(firstDotIndex + 1)
    .replace(/\./g, "")
    .replace(/\D+/g, "")
    .slice(0, Math.max(0, maxDecimal));

  return `${intFormatted}.${decimalPart}`;
};

export default formatInputMoneyMYR;
